import { Observable } from 'rxjs';

import { IDataStoreService, IState, StateData } from './data-store.types';

//

export abstract class AbstractDataStore<D extends StateData, S extends IState<D>>
  implements IDataStoreService<D, S>
{
  abstract readonly state :S;
  abstract readonly state$ :Observable<D>;

  constructor() {}
  /**
   * Call this in non-abstract derived classes' constructors.
   *
   * In abstract derived classes, this can be overridden, but remember to call
   * `super.init();` in the overridden method.
   */
  init() {} // eslint-disable-line @typescript-eslint/no-empty-function

  get<K extends keyof D>(key :K) :D[K] {
    return this.getState()[key];
  }
  getState() :D {
    return this.state.getSnapshot();
  }
  updateState(updates :Partial<D>) :void {
    this.state.update(updates);
  }
}
